// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"87844f62","568":"077b1df5"}[chunkId] + ".chunk.css";
};